/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { INurse } from 'app/shared/model/nurse.model';

export interface IPostOpRecovery {
  id?: string;
  recievedAt?: number;
  carePlan?: string | null;
  careGiven?: string | null;
  dischargedAt?: number;
  patientFirst?: boolean;
  sideRailsUp?: boolean;
  checkMeds?: boolean;
  frequentAssessment?: boolean;
  toiletAssist?: boolean;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  nurse?: INurse;
}

export const defaultValue: Readonly<IPostOpRecovery> = {
  patientFirst: false,
  sideRailsUp: false,
  checkMeds: false,
  frequentAssessment: false,
  toiletAssist: false,
  active: false,
};
